import { primitive } from 'styles/constants';

import { Path, Svg } from '../../../ucl/components/svg/Svg';
export const PaymentMethodsIcon = () => (
  <Svg width="$6" height="$6" viewBox="0 0 24 24" fill="none">
    <Path
      d="M4 20.3975C3.45 20.3975 2.97917 20.2016 2.5875 19.81C2.19583 19.4183 2 18.9475 2 18.3975V6.39746C2 5.84746 2.19583 5.37663 2.5875 4.98496C2.97917 4.59329 3.45 4.39746 4 4.39746H20C20.55 4.39746 21.0208 4.59329 21.4125 4.98496C21.8042 5.37663 22 5.84746 22 6.39746V18.3975C22 18.9475 21.8042 19.4183 21.4125 19.81C21.0208 20.2016 20.55 20.3975 20 20.3975H4ZM4 12.3975H20V8.39746H4V12.3975Z"
      fill={primitive.$bbqBrown}
    />
  </Svg>
);
